export default __webpack_public_path__ + "static/media/logo.932034ab.png";